import {
  ImageSizing as HygraphImageSizing,
  Maybe as HygraphMaybe,
} from '@/lib/types';

import { ImageSizing } from '@/enums/image-sizing';

const map: Partial<Record<HygraphImageSizing, ImageSizing>> = {
  [HygraphImageSizing.MatchHeight]: ImageSizing.MATCH_HEIGHT,
  [HygraphImageSizing.MatchWidth]: ImageSizing.MATCH_WIDTH,
  [HygraphImageSizing.Overflow]: ImageSizing.OVERFLOW,
  [HygraphImageSizing.Image_75]: ImageSizing.IMAGE_75,
};

export default function imageSizingTransformer(
  props: HygraphMaybe<HygraphImageSizing> | undefined
) {
  if (!props) {
    return undefined;
  }

  return map[props];
}
